import { render } from "./v-catalogPage.vue?vue&type=template&id=50563610&scoped=true"
import script from "./v-catalogPage.vue?vue&type=script&lang=js"
export * from "./v-catalogPage.vue?vue&type=script&lang=js"

import "./v-catalogPage.vue?vue&type=style&index=0&id=50563610&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50563610"

export default script